import { OrdemServicoFilters } from '@/types';
import { apiCall } from '@/utils/ordensServicoApi';
import { buildQueryParams } from '@/utils/ordensServicoQueryParams';
import { analyzePaginationStructure } from './ordensServicoApiPagination';
import { extractOrdersFromApiResponse } from './ordensServicoApiDataExtraction';

const ITEMS_PER_PAGE = 999999; // Aumentado de 90000 para 999999
const MAX_PAGES = 50; // Limite de segurança para evitar loops infinitos

export const fetchAllPagesFromApi = async (filters?: OrdemServicoFilters) => {
  const allOrdens: any[] = [];
  let currentApiPage = 1;
  let hasMoreData = true;
  let pagesProcessed = 0;
  
  while (hasMoreData && currentApiPage <= MAX_PAGES) {
    const queryParams = buildQueryParams(filters, currentApiPage);
    
    try {
      const data = await apiCall(`/ordemservico?${queryParams}`);
      
      // Analisar estrutura de paginação
      const paginationInfo = analyzePaginationStructure(data);
      
      // Extrair ordens da resposta
      const pageResult = extractOrdersFromApiResponse(data);
      const ordensNestaPagina = pageResult.ordensData.length;
      
      if (ordensNestaPagina === 0) {
        hasMoreData = false;
        break;
      }
      
      // Adicionar ordens desta página ao array total
      allOrdens.push(...pageResult.ordensData);
      pagesProcessed++;
      
      // Verificar se há mais páginas baseado na estrutura de paginação
      if (paginationInfo.hasMorePages === false) {
        hasMoreData = false;
      } else if (ordensNestaPagina < 100) {
        // Se retornou menos que o limite padrão, provavelmente é a última página
        hasMoreData = false;
      }
      
      currentApiPage++;
      
    } catch (error) {
      // Finalizar busca em caso de erro
      hasMoreData = false;
      break;
    }
  }
  
  if (allOrdens.length === 0) {
    return { ordensData: [], pagesProcessed: 0 };
  }
  
  return { ordensData: allOrdens, pagesProcessed };
};
